import { Check, Close } from "@mui/icons-material";
import { Button, Modal } from "@mui/material";
import React, { useContext, useMemo, useState } from "react";

import { ReactComponent as TipIcon } from "assets/tip.svg";
import { UserContext } from "layouts/SlapshotMainLayout";

import styles from "./TrackingGuide.module.scss";

type Props = {
  id: string;
  step: number;
  title: string;
  description?: string;
  secondaryTitle?: string;
  list: Record<string, string | null>;
  open: boolean;
  videoUrl: string;
};

const TrackingGuide = ({
  id,
  step,
  title,
  description,
  secondaryTitle,
  list,
  open,
  videoUrl,
}: Props) => {
  const user = useContext(UserContext);
  // const tips = useMemo(
  //   () => user?.preferences?.tips || [],
  //   [user?.preferences?.tips],
  // );
  const [hiddenTips, setHiddenTips] = useState<string[]>([]);
  const showTip = open && !hiddenTips.includes(id);

  const handleClose = () => {
    setHiddenTips((prev) => [...prev, id]);
    // user?.setPreferences({
    //   ...user.preferences,
    //   tips: [...tips, id],
    // });
  };

  return (
    <Modal open={showTip} className={styles.modal}>
      <div className={styles.container}>
        <div className={styles.imageContainer}>
          <video
            src={videoUrl}
            autoPlay
            loop
            muted
            playsInline
            style={{
              height: "100%",
              width: "100%",
              objectFit: "contain",
              objectPosition: "center",
              borderRadius: "20px",
            }}
          />
        </div>
        <div className={styles.contentContainer}>
          <div className={styles.innerContainer}>
            <p className={styles.step}>Key Frame {step}/2</p>

            <div className={styles.textContainer}>
              <div>
                <h3
                  className={styles.secondaryTitle}
                  style={{ color: "#00c9a7" }}
                >
                  Do select:
                </h3>

                <div className={styles.list} style={{ paddingBottom: "10px" }}>
                  <div className={styles.listItem}>
                    <h5 className={styles.listItemTitle}>
                      <Check style={{ color: "#00c9a7" }} /> Maximum trackable
                      background
                    </h5>
                    <p>
                      The more trackable area you select the better the track
                    </p>
                  </div>
                </div>

                <h3 className={styles.secondaryTitle}>Do NOT select:</h3>

                <div className={styles.list}>
                  <div className={styles.listItem}>
                    <h5 className={styles.listItemTitle}>
                      <Close /> Moving objects
                    </h5>
                    <p>Like a person walking, car driving, etc.</p>
                  </div>

                  <div className={styles.listItem}>
                    <h5 className={styles.listItemTitle}>
                      <Close /> Textureless elements
                    </h5>
                    <p>Like the sky, an ocean etc.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.actions}>
            <Button className={styles.okBtn} onClick={handleClose}>
              Got it
            </Button>

            <div className={styles.tip}>
              <TipIcon />
              <div>
                <a
                  href="https://support.slapshot.ai/en/support/how-do-i-create-3d-tracks-with-ai-in-slapshot"
                  target="_blank"
                  rel="noreferrer"
                >
                  Click here
                </a>{" "}
                to view our camera tracking tutorial.
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default TrackingGuide;
